module.exports = __webpack_public_path__ + "static/media/formulaSpeed.bad67740.png";